import React from 'react'
import { graphql } from 'gatsby'
import styled from "styled-components"
import Helmet from 'react-helmet'
import { get } from "lodash"

import Layout from '../components/Layout'

const Container = styled.div`
  @media (min-width: 560px) {
    margin-top: 2.5vw;
  }
`
const Row = styled.div`

  &::after {
    content: "";
    clear: both;
    display: table;
  }
`

const CustomColumn = styled.div`

  @media (min-width: 560px) {
    ${props => (props.border && "border-left-style: solid;")}%;
    float: right;
    padding: 20px;
    width: ${props => (props.span ? props.span / 12 * 100 : "8.33")}%;
    text-align: ${props => props.align};
  }

  @media (max-width: 560px) {
    width 90%;
    margin 0 5%;
    float: right;
    padding-top: 20px;
    ${props => (props.border && "border-bottom-style: solid;")}%;
    text-align: right;
  }

`

const ProfilePhoto = styled.div `
  max-width: 30%;

  @media (min-width: 560px) {
    float: left;
  }

  @media (max-width: 560px) {
    float: right;
  }

`

const PersonalDescription = styled.div `

`

const Link =  styled.a`{
  transition: color 0.6s ease;
  text-decoration: none;
  boxShadow: none;

  color: hsla(0,0%,0%,0.8);

  &:hover {
    cursor: pointer;
    color: #0071bc;
  }

}
`

const Category = styled.div `
  transition: all 1s ease;
  overflow: hidden;
  color: inherit;
  font-family: 'Avenir Next','Arial';
  font-weight: bold;
  text-rendering: optimizeLegibility;
  font-size: 2rem;
  line-height: 1.1;

  padding: 10px 0px;

  outline: none;

  &:focus { outline: none; }

  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  .open {
    max-height: 2000px;
  }

  .closed {
    max-height: 0px;
  }

  &:hover {
    cursor: pointer;
  }

`

const SubCategory = styled.div `
  transition: all 1s ease-in-out;
  -webkit-transition: max-height 0.6s ease-in-out;
  -moz-transition: max-height 0.6s ease-in-out;
  -ms-transition: max-height 0.6s ease-in-out;
  -o-transition: max-height 0.6s ease-in-out;
  overflow: hidden;
  font-family: 'Avenir Next','Arial';
  font-weight: bold;
  text-rendering: optimizeLegibility;
  font-size: 1.51572rem;
  line-height: 1.1;

  padding: 10px 0px;

  &:focus { outline: none; }

  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  div.open {
    max-height: 500px;
  }

  div.closed {
    max-height: 0px;
    display: none;
  }

  &:hover {
    cursor: pointer;
  }

`

const Entry = styled.div `
  font-family: 'Avenir Next','Arial';
  font-weight: bold;
  text-rendering: optimizeLegibility;
  font-size: 1rem;
  line-height: 1.1;
  padding: 5px 0px;

  &:focus { outline: none; }

  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
`



function getPostStructure(posts) {
  const categories = posts.map(({ node }) => get(node, 'frontmatter.category')).filter((v, i, a) => a.indexOf(v) === i);
  let categoryStructure = {};
  categories.forEach(function (category){
    let subCategoryStructure = {};
    const sub_categories = posts.filter(({ node }) => get(node, 'frontmatter.category') === category)
                                .map(({ node }) => get(node, 'frontmatter.sub_category'))
                                .filter((v, i, a) => a.indexOf(v) === i);
    sub_categories.forEach(function(sub_category){
      subCategoryStructure[sub_category] = posts.filter(function ({ node }){
                                                          let is_category_match = (get(node, 'frontmatter.category') === category),
                                                              is__sub_category_match = (get(node, 'frontmatter.sub_category') === sub_category);
                                                          return (is_category_match && is__sub_category_match);
                                                      });
    });
    categoryStructure[category] = subCategoryStructure;
  });
  return categoryStructure;
}

class SubCategoryComponent extends React.Component {
  constructor() {
    super()
    this.state = { open : false }
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e) {
    e.stopPropagation();
    this.setState({ open : !this.state.open })
  }


  render(){
    return (
      <SubCategory>
        <span onClick={this.handleClick}>{this.props.sub_category}</span>
        <div class = {this.state.open? "open" : "closed" }>
          {this.props.postStructure[this.props.category][this.props.sub_category].map(({ node }) => {
            const title = get(node, 'frontmatter.title') || node.fields.slug
            return (
              <Entry key={node.fields.slug}>
                <Link href={node.fields.slug}>
                  {title}
                </Link>
              </Entry>
            )
          })}
        </div>
      </SubCategory>
    )
  }
}

class CategoryComponent extends React.Component {
  constructor() {
    super()
    this.state = { open : false }
  }
  render(){
    return (
      <Category>
        <span onClick={() => this.setState({ open : !this.state.open })}>{this.props.category}</span>
        <div class = {this.state.open? "open" : "closed" }>
          {Object.keys(this.props.postStructure[this.props.category])
                  .map(sub_category =>
                        <SubCategoryComponent postStructure = { this.props.postStructure }
                                              category = { this.props.category }
                                              sub_category = { sub_category }
                                              />)
          }
        </div>
      </Category>
    )
  }
}


class BlogIndex extends React.Component {
  render() {
    const config = get(this, 'props.data.config')
    const posts = get(this, 'props.data.allMarkdownRemark.edges')
    const siteTitle = get(config, 'frontmatter.title')
    const description = get(config, 'frontmatter.description')
    const postStructure = getPostStructure(posts)
    return (
      <Layout style="margin: !0px;" location={this.props.location} config={config}>
        <Helmet
          htmlAttributes={{ lang: this.props.pageContext.language }}
          meta={[{ name: 'description', content: description }]}
          title={siteTitle}
        />
        <Container id="div-main">
          <Row margin= "">
          <CustomColumn span="6" align="left" border={true}>
              <div class="link-item">
                  <Row>
                    <ProfilePhoto>
                      <img src="profile.jpg"/>
                    </ProfilePhoto>
                  </Row>
                  <Row>
                    <PersonalDescription>
                      <h3>Gregorio Cabral</h3>
                      <p>software developer <br/> based in Buenos Aires, Argentina <br/>
                         get in touch -
                         <span> <Link target="_blank" href="https://twitter.com/greggocabral">twitter</Link> </span>
                         -
                         <span> <Link target="_blank" href="https://github.com/greggocabral">github</Link> </span>
                      </p>
                    </PersonalDescription>

                  </Row>
              </div>
          </CustomColumn>
            <CustomColumn span="6" align="right">
              {Object.keys(postStructure).map(category =>
                <CategoryComponent category={ category }
                                   postStructure = { postStructure }

                />
              )}
            </CustomColumn>
          </Row>
        </Container>
      </Layout>
    )
  }
}

export default BlogIndex

export const blogIndexFragment = graphql`
  query BlogPost($language: String!) {
    config:markdownRemark(frontmatter: {
      language: { eq: $language }
      type: { eq: "language" }
    }) {
      html
      fields {
        slug
      }
      frontmatter {
        title
        language
        description
      }
    }
    allMarkdownRemark(
        sort: { fields: [frontmatter___date], order: DESC }
        filter: { frontmatter: {
          language: { eq: $language }
          type: { eq: null }
        }}
      ) {
      edges {
        node {
          excerpt
          fields {
            slug
          }
          frontmatter {
            date(formatString: "LL")
            title
            category
            sub_category
          }
        }
      }
    }
  }
`
